import React, { lazy } from 'react';
import { Suspense, useMemo } from 'react';
import ReactDOM from 'react-dom';
import { BUILDER_API_KEY } from 'src/scripts/utils/environment';
import { checkIfCustomer } from 'src/scripts/utils/helpers';
import ErrorBoundary from 'src/scripts/utils/react/ErrorBoundary';

const PageBuilderComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "PageBuilderComponent" */
      '../../Builder/BuilderReactComponent'
    )
);

const BuilderWebComponent = () => {
  const isCustomer = useMemo(() => {
    return checkIfCustomer();
  }, []);
  const userAgent = navigator.userAgent.toLowerCase().includes('aloios') ? 'aloios' : navigator.userAgent;

  if (BUILDER_API_KEY) {
    return (
      <ErrorBoundary>
        <Suspense fallback={null}>
          <PageBuilderComponent model={'web-component-page'} isLoggedIn={isCustomer} userAgent={userAgent} />
        </Suspense>
      </ErrorBoundary>
    );
  }
  return null;
};

export const renderWebComponent = () => {
  const webComponentContentSelector = document.querySelector(WEB_COMPONENT_BUILDER_CONTENT_SELECTOR);
  if (webComponentContentSelector) {
    ReactDOM.render(<BuilderWebComponent />, webComponentContentSelector);
  }
};

const WEB_COMPONENT_BUILDER_CONTENT_SELECTOR = `[react-render-target="builder-dynamic-web-component"]`;
